export const PROPERTY = 'property'

export const property = {
  en: {
    translation: {
      property: {
        propertyTable: {
          generalLabour: 'General Labor',
          propertyManager: 'FPM',
          woDraw: 'WO Draw',
          status: 'Status',
          address: 'Address',
          city: 'City',
          clientStart: 'Client Start',
          clientDue: 'Client Due',
          type: 'Type',
          propertyCoordinator: 'PC',
          accountPayable: 'AP',
          zip: 'Zip',
          client: 'Client',
          sow: 'SOW',
          propertyCost: 'Property Cost',
          paid: 'Paid',
          invoiceNumber: 'Invoice No',
          accountRecievable: 'AR',
          market: 'Market',
          state: 'State',
          woaFinish: 'WOA Finish',
          region: 'Region',
          partialPayment: 'Partial Payment',
          expectedPayment: 'Expected Payment',
          percentagePaid: '% Paid',
          profitMargins: 'Profit Margins',
          profitPercentage: 'Profit %',
          profitTotal: 'Profit Total',
          materialCost: 'Material Cost',
          draw: 'WO Draw',
          sowDraw: 'SOW Draw',
          woNo: 'WO No',
          poNo: 'PO No',
          invoiceDate: 'Invoice Date',
          disqualifiedRevenueFlag: 'Disqualified Revenue',
          unitNo: 'Unit Number',
        },
        propertyFilter: {
          new: 'New',
          active: 'Active',
          punch: 'Punch',
          reconcile: 'Reconcile',
          closed: 'Closed',
          invoiced: 'Invoiced',
          clientPaid: 'Client Paid',
          pastDue: 'Past Due',
          overpayment: 'Overpayment',
          disputed: 'Disputed',
          collection: 'Collection',
        },
        propertySummary: {
          propertyID: 'Property ID',
          status: 'Status',
          client: 'Client',
          propertyDue: 'Property Due',
          fpmName: 'FPM Name',
          fpmContact: 'FPM Contact',
          seeMore: 'See More',
          seeLess: 'See Less',
          address: 'Address',
          propertyName: 'Property Name',
          lockBoxCode: 'Lock Box Code',
          propertyType: 'Property Type',
          clientStart: 'Client Start Date',
          clientEnd: 'Client End Date',
          woaStart: 'WOA Start Date',
          woaEnd: 'WOA End',
          pcName: 'PC Name',
          pcContact: 'PC Contact',
        },
        propertyAmount: {
          finalSOW: 'Final SOW',
          accountPayable: 'Account Payable',
          propertyCost: 'Property Cost',
          revenue: 'Revenue',
          profits: 'Profits',
          profitMargins: 'Profit Margins',
          vendorPayment: 'Vendor Payment',
          materials: 'Materials',
        },
        ganttChart: {
          name: 'Name',
          trade: 'Trade',
          startDate: 'Start Date',
          endDate: 'End Date',
        },
        propertyDetails: {
          transactions: 'Transactions',
          viewDetails: 'View Details',
          newTransaction: 'New Transaction',
          propertyDetails: 'Property Details',
          vendorWorkOrders: 'Vendor Work Orders',
          documents: 'Documents',
          notes: 'Notes',
          upload: 'Upload',
          schedule: 'Schedule',
          auditLogs: 'Audit Logs',
        },
        dueProperties: 'Due Properties',
        export: 'Export',
        newProperty: 'New Property',
        titleLabel: "Property",
      },
    },
  },
  es: {
    translation: {
      property: {
        propertyTable: {
          generalLabour: 'Travail Général',
          propertyManager: 'FPM',
          woDraw: 'Sorteo WO',
          status: 'Estado',
          address: 'Dirección',
          city: 'Ciudad',
          clientStart: 'Inicio del Cliente',
          clientDue: 'Vencimiento del Cliente',
          type: 'Tipo',
          propertyCoordinator: 'PC',
          accountPayable: 'AP',
          zip: 'Código postal',
          client: 'Cliente',
          sow: 'SOW',
          propertyCost: 'Costo del Proyecto',
          paid: 'Pagado',
          invoiceNumber: 'Factura No',
          invoice: 'Factura',
          accountReceivable: 'AR',
          market: 'Mercado',
          state: 'Estado',
          woaFinish: 'Acabado WOA',
          region: 'Región',
          partialPayment: 'Pago Parcial',
          expectedPayment: 'Pago Esperado',
          percentagePaid: '% Payé',
          profitMargins: 'Margen de Ganancia',
          profitPercentage: '% de Ganancia',
          profitTotal: 'Ganancia Total',
          materialCost: 'Costo de Material',
          draw: 'WO Dibujo',
          sowDrow: 'SOW Sorteo',
          woNo: 'WO No',
          poNo: 'PO No',
          invoiceDate: 'Fecha de la factura',
          unitNo: 'Unit Number',
        },
        propertyFilter: {
          new: 'Nuevo',
          active: 'Activo',
          punch: 'Puñetazo',
          reconcile: 'Conciliar',
          closed: 'Cerrado',
          invoiced: 'Facturado',
          clientPaid: 'Cliente pagado',
          pastDue: 'Vencido',
          overpayment: 'Sobrepago',
          disputed: 'Cuestionado',
          collection: 'Recopilación',
        },
        propertySummary: {
          propertyID: 'Propertyo ID',
          status: 'Estado',
          client: 'Cliente',
          propertyDue: 'Proyecto debido',
          address: 'Habla a',
          propertyName: 'Nombre del proyecto',
          lockBoxCode: 'Código de caja de seguridad',
          propertyType: 'Tipo de proyecto',
          clientEnd: 'Fecha de finalización del cliente',
          woaStart: 'Fecha de inicio del WOA',
          woaEnd: 'Fecha de finalización de WOA',
          fpmName: 'FPM nombre',
          fpmContact: 'FPM contacto',
          seeMore: 'Ver más',
          seeLess: 'Ver menos',
          pcName: 'Nombre de la computadora',
          pcContact: 'Contacto de PC',
        },
        propertyAmount: {
          finalSOW: 'SOW Finale',
          accountPayable: 'Cuenta por pagar',
          propertyCost: 'Costo del proyecto',
          revenue: 'Ingresos',
          profits: 'Ganancias',
          profitMargins: 'Márgenes de beneficio',
          vendorPayment: 'Pago del proveedor',
          materials: 'Materiales',
        },
        ganttChart: {
          name: 'Nombre',
          trade: 'Comercio',
          startDate: 'Fecha de inicio',
          endDate: 'Fecha final',
        },
        propertyDetails: {
          transactions: 'Transaccións',
          viewDetails: 'Ver detalles',
          newTransaction: 'Nueva Transacción',
          propertyDetails: 'Detalles de ganancias',
          schedule: 'Calendario',
          vendorWorkOrders: 'Órdenes de Trabajo del Proveedor',
          documents: 'Documentos',
          notes: 'Notas',
          upload: 'Subir',
          auditLogs: 'Registros de auditoría',
        },
        dueProperties: 'Proyectos Vencidos',
        export: 'Exportar',
        newProperty: 'Nueva propiedad',
        titleLabel: "Propiedad"
      },
    },
  },
}

export const NEW_PROPERTY = 'newProperty'

export const new_property = {
  en: {
    translation: {
      [NEW_PROPERTY]: {
        // Modal
        title: 'New Property',
        propertyInformation: 'Property Information',
        propertyFieldInformation: 'Property Information',
        propertyManagement: 'Property Management',

        // Property Table
        propertyID: 'Property ID',
        WOstatus: 'WO Status',
        WoID: 'WO ID',
        trade: 'Trade',
        dueDateWO: 'Due Date WO',
        expectedPaymentDate: 'Expected Payment Date',

        // Property Information Form
        name: 'Name',
        type: 'Type',
        woNumber: 'WO Number',
        poNumber: 'PO Number',
        clientStartDate: 'Client Start Date',
        clientDueDate: 'Client Due Date',
        woStartDate: 'WOA Start Date',
        originalSOWAmount: 'Original SOW Amount',
        uploadPropertySOW: 'Upload Property SOW',
        chooseFile: 'Choose File',
        fileFormat: 'Please select a valid file format (pdf, png, jpg, jpeg)',

        // Property Property Form
        propertyId: 'Property ID',
        existAddressMessage: 'using this address already exists',
        acknowledged: 'Acknowledged',
        address: 'Address',
        city: 'City',
        state: 'State',
        zipCode: 'Zip Code',
        market: 'Market',
        gateCode: 'Gate Code',
        lockBoxCode: 'Lock Box Code',
        hoaPhone: 'HOA Phone',
        hoaContactEmail: 'HOA Contact Email',
        ext: 'Ext',
        cancel: 'Cancel',
        next: 'Next',

        // Property Management Form
        fieldPropertyManager: 'Field Property Manager',
        propertyCoordinator: 'Property Coordinator',
        client: 'Client',
        clientSuperName: 'Client Super Name',
        superPhoneNumber: 'Super Phone',
        superEmail: 'Super Email',
        save: 'Save',

        residentInformation: "Resident Information",

        unitNumber: "Unit Number",
        clientLabel: "Client",
        notes: "Notes"
      },
    },
  },
  es: {
    translation: {
      [NEW_PROPERTY]: {
        // Modal
        title: 'Nuevo Proyecto',
        propertyInformation: 'Información del Proyecto',
        propertyFieldInformation: 'Información del Inmueble',
        propertyManagement: 'Gestión del Proyecto',

        // Property Table
        propertyID: 'Propertyo ID',
        WOstatus: 'Estado de OT',
        WoID: 'ID de OT',
        trade: 'Comercio',
        dueDateWO: 'Fecha de vencimiento OT',
        expectedPaymentDate: 'Fecha de pago esperada',

        // Property Information Form
        name: 'Nombre',
        type: 'Tipo',
        woNumber: 'Número de WO',
        poNumber: 'Número de PO',
        clientStartDate: 'Fecha de Inicio del Cliente',
        clientDueDate: 'Fecha de Vencimiento del Cliente',
        woStartDate: 'Fecha de Inicio del WOA',
        originalSOWAmount: 'Monto Original del SOW',
        uploadPropertySOW: 'Subir SOW del Proyecto',
        chooseFile: 'Seleccionar Archivo',

        // Property Property Form
        propertyId: 'ID del Proyecto',
        existAddressMessage: 'ya existe una dirección con este nombre',
        acknowledged: 'Aceptado',
        address: 'Dirección',
        city: 'Ciudad',
        state: 'Estado',
        zipCode: 'Código Postal',
        market: 'Mercado',
        gateCode: 'Código de Puerta',
        lockBoxCode: 'Código de Caja',
        hoaPhone: 'Teléfono de HOA',
        ext: 'Ext',
        hoaContactEmail: 'Correo de Contacto de HOA',
        cancel: 'Cancelar',
        next: 'Siguiente',

        // Property Management Form
        fieldPropertyManager: 'Gerente de Proyecto',
        propertyCoordinator: 'Coordinador de Proyecto',
        client: 'Cliente',
        clientSuperName: 'Supervisor del Cliente',
        superPhoneNumber: 'Teléfono del Supervisor',
        superEmail: 'Correo del Supervisor',
        save: 'Guardar',
        fileFormat: 'Seleccione un formato de archivo válido (pdf, png, jpg, jpeg)',

        residentInformation: "Información residente",
        notes: 'Notas'
      },
    },
  },
}

